import apiHandler from './apiHandler';

const { publicRequest } = apiHandler;

function getAlarmsFields({
  next, offset, limit, signal,
}) {

  if (next) {

    const nextEndpoint = next.replace('http', 'https');
    return publicRequest(nextEndpoint, { reqAuth: true, signal });

  }

  const params = { offset, limit };
  const cleanParams = JSON.parse(JSON.stringify(params || {}));
  // eslint-disable-next-line no-unused-vars
  const queryParams = new URLSearchParams(cleanParams);

  return publicRequest('/telemetry/field', {
    reqAuth: true,
    signal,
  });

}

export default { getAlarmsFields };
